const FlyCard = ({ name, sizes, image, alt, why, when }) => (
  <div className="bg-[#1E2328] rounded-2xl shadow-lg overflow-hidden border border-white/10 hover:shadow-xl transition-all duration-300">
    <div className="bg-[#1E2328] flex items-center justify-center" style={{ height: '250px' }}>
      <img src={image} alt={alt} className="w-full h-full object-cover" />
    </div>
    <div className="p-6">
      <h3 className="text-xl font-bold text-white mb-2">{name}</h3>
      <p className="text-[#3aa0e0] font-semibold mb-3">{sizes}</p>
      <p className="text-slate-400 mb-2"><strong>Why:</strong> {why}</p>
      <p className="text-slate-400"><strong>When:</strong> {when}</p>
    </div>
  </div>
);

export default FlyCard;
